if (history.length > 1) {
    const goBackButtons = document.querySelectorAll('.bop-go-back');

    if (goBackButtons) {
        goBackButtons.forEach(function (e) {
            e.classList.remove('hidden')
            e.addEventListener('click', () => {
                history.back();
            })
        });
    }
}
